// @flow
import * as React from 'react';
import MultiSelect from 'components/MultiSelect';
import { updateObject } from 'utils/functional';
import Field from './Field';

const MultiSelectField = ({
  name,
  label,
  description,
  options,
  ...props
}: {
  name: string,
  label?: string,
  description?: string,
  options: Array<{ value: string, label: string }>
}) => (
  <Field
    inputProps={updateObject(props, { options })}
    name={name}
    label={label}
    description={description}
    renderInput={({ value, id, qaId, hasError, updateValue }) => (
      <MultiSelect
        id={id}
        name={name}
        value={value}
        options={options}
        hasError={hasError}
        data-qa-id={qaId}
        onChange={updateValue}
        label={label}
        {...props}
      />
    )}
  />
);

export default MultiSelectField;
